export enum EmployeeStatus {
  "Active" = "ACTIVE",
  "Created" = "CREATED",
  "Inactive" = "INACTIVE",
  "Deleted" = "DELETED",
}

